module.exports = __webpack_public_path__ + "img/schadowplatz_2k.afffbc1d.png";